import React from 'react';
import { Users, DollarSign, Globe, Clock } from 'lucide-react';

const StatsSection: React.FC = () => {
  const stats = [
    {
      icon: <Users size={24} className="text-[#1c9e86]" />,
      value: "10,000+",
      label: "Happy Customers",
      description: "Businesses trust our services"
    },
    {
      icon: <DollarSign size={24} className="text-[#1c9e86]" />,
      value: "$400MN+",
      label: "Transactions Processed",
      description: "Securely handled annually"
    },
    {
      icon: <Globe size={24} className="text-[#1c9e86]" />,
      value: "100+",
      label: "Countries Covered",
      description: "Global payment reach"
    },
    {
      icon: <Clock size={24} className="text-[#1c9e86]" />,
      value: "24 hrs",
      label: "Account Setup",
      description: "Fast onboarding process"
    }
  ];

  return (
    <section className="py-8 sm:py-10 text-center bg-white lg:px-[13%] border-t border-b border-gray-100 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="p-4 sm:p-6 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="p-2 sm:p-3 bg-[#ecf6f3] rounded-lg inline-block mb-4">
                {stat.icon}
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                {stat.value}
              </h3>
              <p className="text-base sm:text-lg font-medium text-gray-700 mb-1">
                {stat.label}
              </p>
              <p className="text-xs sm:text-sm text-gray-500">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;